import Vue from 'vue';
import Vuex from 'vuex';
import app from '@/helpers/app';

// import settings from './module/settings';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    customerTaxId: '',
    userRole: 0,
    user: null,
    token: null,
    name: '',
    email: ''
  },

  mutations: {
    setEmail(state, newEmail) {
      state.email = newEmail;
    },

    setName(state, newName) {
      state.name = newName;
    },

    setCustomerTaxId(state, newCustomerTaxId) {
      state.customerTaxId = newCustomerTaxId;
    },

    setUserRole(state, newUserRole) {
      state.userRole = newUserRole;
      app.persistUserRoleToStorage(newUserRole);
    },

    setUser(state, user) {
      state.user = user;
      // app.persistAuthenticationUserToStorage(user);
    },

    setToken(state, token) {
      state.token = token;
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js